<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>工具包发放</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover">
      <!-- 搜索 -->
      <el-form :inline="true" size="small" v-model="listQuery">

        <el-form-item label="工具单编号">
          <el-input v-model="listQuery.toolId" placeholder="请输入工具单编号" clearable></el-input>
        </el-form-item>
        <el-form-item label="发放状态">
          <el-select v-model="listQuery.disStatus" clearable placeholder="请选择">
            <el-option v-for="(item, index)  in disStatusMap" :key="index" :label="item" :value="index"/>
          </el-select>
        </el-form-item>
        <el-form-item label="工具包类型">
          <el-select v-model="listQuery.toolType" clearable placeholder="请选择类型">
            <el-option v-for="(item, index)  in toolTypeMap" :key="index" :label="item" :value="index"/>
          </el-select>
        </el-form-item>

        <el-form-item label="服务者编号">
          <el-input v-model="listQuery.relationWorkerNo" placeholder="请输入服务者编号" clearable></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="listQuery.relationWorkerName" placeholder="请输入服务者姓名" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="listQuery.relationWorkerTel" placeholder="请输入服务者手机号" clearable></el-input>
        </el-form-item>

        <el-form-item label="关联订单号">
          <el-input v-model="listQuery.relationOrderNo" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="时间范围">
          <el-date-picker v-model="listQuery.createTimes" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
                          range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"
                          :picker-options="{}"></el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
          <el-button icon="el-icon-plus" type="primary" plan @click="postPackage">发放工具包</el-button>
        </el-form-item>
      </el-form>

      <!-- 列表数据 -->
      <el-table :data="listData" border style="width: 100%" class="table">
        <el-table-column prop="id" label="ID" width="50px"></el-table-column>

        <el-table-column prop="kitNo" label="套餐编号"></el-table-column>
        <el-table-column prop="spuCode" label="商品SPU"></el-table-column>
        <!-- <el-table-column prop="toolkitBom" label="工具包组成快照"></el-table-column> -->

        <el-table-column prop="toolkitType" label="工具包类型">
          <template slot-scope="scope">
            <el-tag>
              {{ toolTypeMap[scope.row.toolkitType] }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="disStatus" label="发放状态">
          <template slot-scope="scope">
            {{ disStatusMap[scope.row.disStatus] }}
          </template>
        </el-table-column>
        <el-table-column prop="failReason" label="失败原因" />
        <el-table-column prop="needComplete" label="是否需要收集工具包信息">
          <template slot-scope="scope">
            <span v-if="scope.row.needComplete">需要</span>
            <span v-else>不需要</span>
          </template>
        </el-table-column>

        <!-- <el-table-column prop="detailList" label="工具包详情">
        </el-table-column>  -->
        <el-table-column prop="relationOrderNo" label="关联订单号"></el-table-column>
        <el-table-column prop="relationWorkerNo" label="服务者编号"></el-table-column>
        <el-table-column prop="relationWorkerName" label="姓名"></el-table-column>
        <el-table-column prop="relationWorkerTel" label="手机"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" :formatter="dateFormatA"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" :formatter="dateFormatA"></el-table-column>

        <el-table-column prop label="操作" fixed="right" width="120px" align="center">
          <template slot-scope="scope">
            <el-button type="danger" plain @click="cancelTool(scope.row)" v-if="scope.row.disStatus == 1"
                       class="red" size="mini">取消发放
            </el-button>
            <el-button plain @click="showDetail(scope.row)" size="mini">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch"/>
    </el-card>


    <el-dialog title="商品详情" :visible.sync="detailVisable" width="1200px" :close-on-click-modal="false" center>

      <el-row style="color:red;">价格:(服务者确认领取时所选sku规格对应的单价)</el-row>
      <el-table :data="detailList" border style="width: 100%" class="table" fit>
        <el-table-column prop="spuCode" label="SPU编码" fixed="left"></el-table-column>
        <el-table-column prop="defaultChoice" label="默认商品sku"></el-table-column>
        <el-table-column prop="canChoiceSkus" label="可选商品SKU"></el-table-column>
        <el-table-column prop="canChoiceProps" label="可选商品规格"></el-table-column>
        <el-table-column prop="finalChoice" label="商家选定sku"></el-table-column>
        <el-table-column prop="name" label="商品sku名称"></el-table-column>
        <el-table-column prop="num" label="商品sku数量"></el-table-column>
        <el-table-column prop="price" label="价格"></el-table-column>

      </el-table>

      <span slot="footer" class="dialog-footer">
                <el-button @click="detailVisable = false" type="primary">关闭</el-button>
            </span>
    </el-dialog>

    <el-dialog title="工具包" :visible.sync="showff" :close-on-click-modal="false" width="700px" center
               class="person-dialog">
      <el-form :inline="true" label-width="100px">
        <el-row>
          <el-form-item label="城市">
            <el-select v-model="addFrom.cityId" clearable placeholder="请选择城市" filterable>
              <el-option v-for="(item, index) in cityList" :key="index" :label="item.cityName"
                         :value="item.id + ''"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="驿站">
            <el-select v-model="addFrom.postStationId" @change="getAllWorker" clearable placeholder="请选择驿站"
                       filterable>
              <template v-for="(item, index) in postStationList">
                <el-option :key="index" v-if="item.cityId == addFrom.cityId" :label="item.postStationName"
                           :value="item.id + ''"></el-option>
              </template>
            </el-select>
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item label="服务站">
            <el-select v-model="addFrom.stationId" @change="getAllWorker" clearable placeholder="请选择服务站"
                       filterable>
              <template v-for="(item, index) in allStationList">
                <el-option :key="index" v-if="item.postStationId == addFrom.postStationId"
                           :label="item.stationName" :value="item.id + ''"></el-option>
              </template>
            </el-select>
          </el-form-item>

          <el-form-item label="服务者">
            <el-select v-model="addFrom.workerNo" clearable placeholder="请选择服务者" filterable>
              <el-option v-for="(item, index) in allWorkerData" :key="index" :label="item.workerName"
                         :value="item.workerNo">
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="发放类型">
            <el-select v-model="addFrom.generateType" clearable placeholder="请选择类型">
              <el-option v-for="(item, index)  in toolTypeMap" :key="index" :label="item" :value="index"/>
            </el-select>
          </el-form-item>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
                <el-button @click="showff = false">取 消</el-button>
                <el-button type="primary" @click="send">确认发送</el-button>
            </span>
    </el-dialog>


  </div>
</template>
<script>
import Pagination from "../common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import workercrmapi from "@/script/api/workercrmapi";
import globalData from "@/components/common/globaldata/global.data.vue";
import "./css/index.css";

export default {
  components: {Pagination},
  data() {
    return {
      addFrom: {
        cityId: null,
        postStationId: null,
        stationId: null,
        workerNo: null,
        generateType: null,
      },

      cityList: [],
      postStationList: [],
      allStationList: [],
      allWorkerData: [],

      showff: false,
      detailVisable: false,
      detailList: [],
      listData: [],
      total: 0,
      pageSize: 10,
      currentPage: 1, //当前页
      listQuery: {
        toolId: '',
        disStatus: '',
        toolType: '',
        relationWorkerNo: '',
        relationWorkerName: '',
        relationWorkerTel: '',
        relationOrderNo: '',
        createTimes: [],

      },
      //发放状态  1初始化中 2 已生成待同意 3 已同意待发放(不需收集信息) 4 不同意发放结束 5已同意待发放(已收集具体信息) 6 发放成功 7取消发放
      disStatusMap: {
        1: '初始化',
        2: '已生成待同意',
        3: "已同意待发放",
        4: '不同意发放结束',
        5: '已同意待发放',
        6: '发放成功',
        7: '取消发放',
        8: '发放失败',
        9: '发放中'
      },
      toolTypeMap: {
        1: '上线包',
        2: '晋升包',
        3: "月度包",
      },

    };
  },
  created() {
    this.querySearch();

  },
  methods: {
    send() {
      if (this.addFrom.workerNo == null || this.addFrom.workerNo == '') {
        this.$message.error("请选择服务者");
        return;
      }
      ;
      if (this.addFrom.generateType == null || this.addFrom.generateType == '') {
        this.$message.error("请选择发放类型");
        return;
      }
      ;
      wmsApi.$axiosAutodisgenerate({
        workerNo: this.addFrom.workerNo,
        generateType: this.addFrom.generateType
      }).then((res) => {
        if (res.data.errno == 0) {
          this.showff = false;
          this.$message.success("操作成功");
          this.querySearch();
        }
      });

    },
    postPackage() {
      this.showff = true;
      this.addFrom = {
        cityId: null,
        postStationId: null,
        stationId: null,
        workerNo: null,
        generateType: null,
      };
      this.getAllCity();
      this.getAllPostStation();
      this.getAllStationList();
    },
    showDetail(row) {
      this.detailVisable = true;
      this.detailList = row.detailList;
    },
    cancelTool(row) {
      //删除工具包
      this.$confirm("是否确认取消?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          wmsApi.$axiosCancelToolKit({
            toolId: row.id,
          })
            .then((res) => {
              if (res.data.errno == 0) {
                this.$message.success("操作成功");
                this.querySearch();
              }
            });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    //查询
    querySearch() {

      this.listQuery.page = this.currentPage;
      this.listQuery.size = this.pageSize;
      wmsApi
        .$axiosToolKitList(this.listQuery)
        .then((res) => {
          this.listData = res.data.data.list;
          this.total = res.data.data.total;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAllWorker() {
      if (this.addFrom.cityId == null || this.addFrom.cityId == "") {
        return; //至少选择城市
      }
      let req = {
        cityId: this.addFrom.cityId,
        postStationId: this.addFrom.postStationId,
        stationId: this.addFrom.stationId,
      };
      workercrmapi.$ajaxWorkerSupplierGetWorker(req).then((res) => {
        if (res.data.errno == 0) {
          this.allWorkerData = res.data.data;
        }
      });
    },
    getAllPostStation() {
      //驿站
      workercrmapi.$axiosPostStationgetAllList({userId: globalData.userInfo.id}).then((res) => {
        if (res.data.errno == 0) {
          this.postStationList = res.data.data;
        }
      });
    },
    getAllCity() {
      //城市下拉框
      wmsApi.$axiosgetallCity({userId: globalData.userInfo.id}).then((res) => {
        if (res.data.errno == 0) {
          this.cityList = res.data.data;
        }
      });
    },
    getAllStationList() {
      //服务站
      wmsApi.$axiosGetAllStationList({userId: globalData.userInfo.id}).then((res) => {
        if (res.data.errno == 0) {
          this.allStationList = res.data.data;
        }
      });
    },

  },
};
</script>
<style scoped>
.crumbs {
  margin: 0 0 10px 0;
}

.btn-margin .el-button--small {
  margin: 10px 12px 0 0;
}

.el-image img {
  height: 60px;
  width: 60px;
  margin: 0 12px 12px 0;
  object-fit: cover;
}
</style>
